import { Col, Row } from 'antd';
import React, { useMemo } from 'react';
import VoucherAmountButton from './voucher-amount-button';
import './voucher-amount-picker.scss';

export interface IVoucherAmountPickerProps {
    voucherAmmounts: number[];
    defaultSelected?: number;
    currencySymbol: string;
    discountPercentage?: number;
    showTicketLabels?: boolean;
    onChange?: (voucherAmmount: number, buttonIndex: number) => void;
}

const VoucherAmountPicker: React.FunctionComponent<IVoucherAmountPickerProps> = (props) => {
    const { voucherAmmounts, defaultSelected, currencySymbol, discountPercentage, showTicketLabels, onChange } = props;

    const memoButtons = useMemo(() => {
        const buttons: Array<React.ReactNode> = [];
        for (let index = 0; index < voucherAmmounts.length; index++) {

            const buttonVoucherAmount = voucherAmmounts[index] ?? 0;

            buttons.push(
                <VoucherAmountButton
                    key={index}
                    buttonIndex={index}
                    selected={index === defaultSelected}
                    onClick={onChange}
                    voucherAmount={buttonVoucherAmount}
                    currencySymbol={currencySymbol}
                    discountPercentage={discountPercentage}
                    showTicketLabel={showTicketLabels ?? true}
                />
            );
        }
        return buttons;
    }, [voucherAmmounts, defaultSelected, currencySymbol, discountPercentage, showTicketLabels, onChange]);

    return (
        <section>
            <Row justify="start" align="top" className={`zl-voucher-amount-picker-container ${voucherAmmounts?.length === 6 ? 'zl-six-buttons' : ''}`}>
                <Col span={24}>{memoButtons}</Col>
            </Row>
        </section>
    );
};

export default VoucherAmountPicker;
